import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-38f1d812")

_pushScopeId("data-v-38f1d812")
const _hoisted_1 = {
  key: 0,
  class: "resource-holder"
}
const _hoisted_2 = { class: "tile-holder" }
const _hoisted_3 = { class: "resource-row" }
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = { class: "title-holder" }
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "th" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.showRelatedResources)
    ? (_openBlock(), _createBlock("section", _hoisted_1, [
        _createVNode("h2", {
          class: "main-title",
          innerHTML: _ctx.translateLabels('Related Resources')
        }, null, 8, ["innerHTML"]),
        _createVNode("div", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.resources, (r, i) => {
            return (_openBlock(), _createBlock("a", {
              class: "icon-color tile",
              key: i,
              href: r.link,
              title: _ctx.translateResource(r).title,
              onClick: _withModifiers(($event: any) => (_ctx.onResourceClick(r)), ["prevent"])
            }, [
              _createVNode("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode("div", {
                    class: "svg-holder",
                    innerHTML: _ctx.getResourceSvg(r.icon)
                  }, null, 8, ["innerHTML"])
                ]),
                _createVNode("div", _hoisted_5, [
                  _createVNode("div", _hoisted_6, [
                    _createVNode("p", {
                      innerHTML: _ctx.getResourceLabel(r.icon)
                    }, null, 8, ["innerHTML"])
                  ]),
                  _createVNode("div", _hoisted_7, [
                    _createVNode("p", {
                      class: "title",
                      innerHTML: _ctx.translateResource(r).title
                    }, null, 8, ["innerHTML"])
                  ])
                ])
              ])
            ], 8, ["href", "title", "onClick"]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
})